export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10986.d9678ba2.jpg";